// extracted by mini-css-extract-plugin
export var lModalMenu__list__item = "Hg";
export var aTitle1 = "Ig";
export var lModalMenuBg = "Jg";
export var lModalMenuButton = "Kg";
export var lModalMenu = "Lg";
export var lModalMenu__inner = "Mg";
export var lModalMenu__list = "Ng";
export var aInner = "Og";
export var aTitle2 = "Pg";
export var lModalMenu__list2 = "Qg";
export var lModalMenu__footer = "Rg";
export var lModalMenu__footer__menu = "Sg";
export var lModalMenu__footer__copyright = "Tg";
export var animationMarquee = "Ug";